
<template>
    <input
      type="text"
      v-on:focus="selectAll"
      v-bind:value="hora"
      v-on:input="updateValue($event.target.value)"
      v-on:blur="handleBlur"
      placeholder="00:00"
      ref="hora"
      @keydown.enter="focusControl">
</template>

<script>
import { SysVars } from '../main'
import { hasHiddenParent } from '../shared/utils';

export default {
    props: {
      value: { String },
    },

    data () {
      return {
        hora: this.value,
        horaAjustada: '',
        focused: false,
        isUpdateValue: false,

      }
    },

    mounted () {

    },

    created () {

    },

    methods: {
      updateValue: function(value) {
        this.isUpdateValue = true
        this.hora = value.replace(/\D/g, '')
        if (this.validaHora(this.hora)) {
          this.$emit('input', this.horaAjustada)
        }
      },

      handleBlur: function() {
        this.focused = false
        let hora = this.$refs.hora.value
        if (hora) {
          if (!this.validaHora(hora)) {
            this.$emit('input', null)
            this.$refs.hora.focus()
            this.$erpToastError('Informe uma hora válida')
          } else
            this.$refs.hora.value = this.horaAjustada
        }
      },

      validaHora: function (hora) {
        if (!hora) return false

        this.horaAjustada = String(hora).replace(':', '')

        if (String(this.horaAjustada).length == 2)
          this.horaAjustada = this.horaAjustada + '00'
        else
        if (String(this.horaAjustada).length == 1)
          this.horaAjustada = this.horaAjustada + '000'
        else
        if (String(this.horaAjustada).length == 3)
          this.horaAjustada = this.horaAjustada + '0'
        else
        if (String(this.horaAjustada).length > 4)
          return false

        if (this.horaAjustada.substr(0,2) > 23)
          return false

        if (this.horaAjustada.substr(2,2) > 59)
          return false

        this.horaAjustada = this.$formatHora(this.horaAjustada)

        return true

      },

      selectAll: function(event) {
        // if (this.$refs.hora.value) {
        //   this.$refs.hora.value = this.hora.replace(/\D/g, '')
        // }
        this.focused = true
        // Workaround for Safari bug
        // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
        setTimeout(function() {
          event.target.select()
        }, 0)
      },

      focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },

      focus: function () {
          if (this.$refs.hora) {
              this.$refs.hora.focus()
          }
      },

    },
    watch: {
      value: function (value) {
        if (!this.isUpdateValue) {
          this.$refs.hora.value = value
        }
        this.isUpdateValue = false
      }
    }

}
</script>

<style scoped>
  input {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/input-hora.vue